import { CircleAlert, Check } from 'lucide-react'
import type { FitThesis } from '@ispot/shared'
import { stageProgressFor, totalProgress } from './fitThesisStages'

export function FitThesisStatusPill({ thesis }: { thesis: FitThesis }) {
  const total = totalProgress(stageProgressFor(thesis))

  if (thesis.status === 'validated') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-success-bg px-2.5 py-1 text-caption font-medium text-success-fg">
        <Check className="h-3 w-3" /> Validated
      </span>
    )
  }
  if (thesis.status === 'complete') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-success-bg px-2.5 py-1 text-caption font-medium text-success-fg">
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--color-success-fg)' }} />
        Complete 9/9
      </span>
    )
  }
  if (thesis.status === 'gap') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-danger-bg px-2.5 py-1 text-caption font-medium text-danger-fg">
        <CircleAlert className="h-3 w-3" /> Gap {total}/9
      </span>
    )
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-warning-bg px-2.5 py-1 text-caption font-medium text-warning-fg">
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--color-warning-fg)' }} />
      Draft {total}/9
    </span>
  )
}
